<template>
    <div class="shipment-page">
        <div class="table-container">
            <!-- 标题区域 -->
            <div class="page-header">
                <div class="header-bar"></div>
                <div class="header-content">
                    <h2 class="header-title">出库单</h2>
                    <div class="header-sub">OUTBOUND ORDER</div>
                </div>
            </div>

            <el-form ref="form" :model="form" :rules="rules" label-width="auto" label-position="left" class="form-body">
                <!-- 客户名称 -->
                <div class="customer-row">
                    <span class="customer-label"><span class="required-star">*</span>客户名称</span>
                    <el-input v-model="form.customerName" clearable placeholder="请输入客户名称" size="small" class="customer-input"></el-input>
                </div>

                <!-- 出库表格 -->
                <el-table
                    :data="form.contentList"
                    :span-method="handleSpan"
                    border
                    size="small"
                    class="content-table"
                    :header-cell-style="{ background: '#F5F7FA', color: '#606266', fontWeight: 600, textAlign: 'center', fontSize: '13px' }"
                    :cell-style="{ textAlign: 'center' }">
                    <el-table-column prop="index" label="序号" align="center" width="70">
                        <template slot-scope="scope">
                            <span v-if="scope.row.total" class="total-label">{{ scope.row.categoryName }}</span>
                            <span v-else-if="scope.row.remarkLast" class="total-label">{{ scope.row.categoryName }}</span>
                            <span v-else class="row-index">{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="categoryName" align="center" label="品名" min-width="140">
                        <template slot-scope="{ row }">
                            <template v-if="!row.total && !row.remarkLast">
                                <el-autocomplete
                                    popper-class="my-autocomplete"
                                    v-model="row.categoryName"
                                    :fetch-suggestions="querySearch"
                                    placeholder="请输入内容"
                                    size="small">
                                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                    <template slot-scope="{ item }">
                                        <div class="name">{{ item.value }}</div>
                                    </template>
                                </el-autocomplete>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" align="center" label="数量" width="160">
                        <template slot-scope="{ row }">
                            <span v-if="row.total" class="total-number">{{ totalQuantity }}</span>
                            <el-input-number v-else size="small" style="width:130px" v-model="row.quantity" :step="1"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="units" align="center" label="单位" width="100">
                        <template slot-scope="{ row }">
                            <template v-if="!row.total && !row.remarkLast">
                                <el-input v-model="row.units" clearable size="small" class="input-center"/>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="价格" align="center" prop="unitPrice" width="160">
                        <template slot-scope="{ row }">
                            <template v-if="!row.total && !row.remarkLast">
                                <el-input-number size="small" style="width:130px" v-model="row.unitPrice" :precision="2" :step="1"></el-input-number>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="货款" align="center" prop="paymentGoods" width="100">
                        <template slot-scope="{ row }">
                            <template v-if="!row.total && !row.remarkLast">
                                <el-input v-model="row.paymentGoods" clearable size="small"/>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" prop="remark" header-align="center" align="left" min-width="260">
                        <template slot-scope="{ row }">
                            <el-input type="textarea"
                                v-if="!!row.rows"
                                v-model="row.remark"
                                clearable
                                size="small"
                                class="remark-textarea"
                                :autosize="{ minRows: 3, maxRows: 6 }">
                            </el-input>
                            <el-input type="textarea"
                                v-else-if="!row.total && !row.remarkLast"
                                v-model="row.remark"
                                clearable
                                size="small"
                                :autosize="{ minRows: 1, maxRows: 6 }">
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center" width="100">
                        <template slot-scope="{ $index }">
                            <div class="action-btn-group">
                                <el-button class="icon-circle-btn icon-add" size="mini" icon="el-icon-plus" circle @click="addRow($index)" title="添加一行"></el-button>
                                <el-button v-if="$index > 0" class="icon-circle-btn icon-delete" size="mini" icon="el-icon-minus" circle @click="deleteRow($index)" title="删除"></el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 底部签名栏 -->
                <div class="footer-signatures">
                    <span class="sig-item"><strong>制单：</strong></span>
                    <span class="sig-item"><strong>财务：</strong></span>
                    <span class="sig-item"><strong>仓库：</strong></span>
                    <span class="sig-item"><strong>客户签名：</strong></span>
                </div>
            </el-form>
        </div>

        <!-- Shipment 子组件 -->
        <div class="table-container flow-container" v-if="!!shipmentId">
            <div class="page-header flow-header">
                <div class="header-bar"></div>
                <div class="header-content">
                    <h2 class="header-title">发货信息</h2>
                    <div class="header-sub">SHIPPING INFO</div>
                </div>
            </div>
            <div class="shipment-wrap">
                <Shipment :shipmentId="shipmentId" @child-event="handleChildEvent"/>
            </div>
        </div>

        <!-- 底部操作栏 -->
        <div class="fixed-bottom-bar">
            <el-button plain size="medium" @click="goBack">返 回</el-button>
            <el-button type="primary" size="medium" @click="saveOutEntre">保 存</el-button>
            <el-button type="success" size="medium" @click="submitAndFlow">提 交</el-button>
        </div>
    </div>
</template>
<script>
    import {outEntrepotDetailById, submitAndFlowOutEntrepot, saveOutEntrepot, editOutEntrepot } from "@/api/api.js";
    import Shipment from "./info/Shipment.vue";
    import webSocketService from '@/utils/WebSocketService';
    export default {
        name: "outEntrepotUpdate",
        components: {Shipment},
        data() {
            return{
                id: this.$route.query.id,
                shipmentId: this.$route.query.shipmentId,
                shipmentNo: null,
                restaurants: [
                    { "value": "电信卡" },
                    { "value": "移动卡" },
                    { "value": "联通卡" },
                    { "value": "国际卡" },
                    { "value": "eSIM卡" },
                    { "value": "vSIM卡" },
                    { "value": "二维码" }
                ],
                noticeRemark:'.物联卡机卡绑定，更换设备或被销卡，请联系客服查询；请勿插在手机等移动端使用，经检测将被关停。\n.本产品仅限于在规定的广告机设备上使用，请勿用作他途。',
                form:{
                    contentList:[
                        {quantity:1,unitPrice:0.00}
                        ,{total: true,categoryName:'合计',remark:'.物联卡机卡绑定，更换设备或被销卡，请联系客服查询；请勿插在手机等移动端使用，经检测将被关停。\n.本产品仅限于在规定的广告机设备上使用，请勿用作他途。',rows:2}
                        ,{remarkLast: true,categoryName:'备注',remark:'ICCID卡号：（请与实物核对卡号）',rows:4}
                    ]
                },
                rules: {
                    customerName: [
                        { required: true, message: '请输入客户名称', trigger: 'blur' },
                    ],
                }
            }
        },
        computed: {
            totalQuantity() {
                return this.form.contentList
                    .filter(item => !item.total && !item.remarkLast)
                    .reduce((sum, item) => sum + (item.quantity || 0), 0);
            }
        },
        methods: {
            goBack() {
                this.$store.dispatch('tagsView/delView', this.$route);
                this.$router.push("/shipment/outEntrepot");
            },
            handleSpan({ row, column, rowIndex, columnIndex }) {
                if (row.total) {
                    if (columnIndex === 0) {
                        return { rowspan: 1, colspan: 2 };
                    } else if (columnIndex < 2) {
                        return { rowspan: 1, colspan: 0 };
                    } else if (columnIndex === 2) {
                        return { rowspan: 1, colspan: 1 };
                    } else if (columnIndex === 6) {
                        return { rowspan: 1, colspan: 5 };
                    }else {
                        return { rowspan: 1, colspan: 0 };
                    }
                } else if (row.remarkLast) {
                    if (columnIndex === 0) {
                        return { rowspan: 1, colspan: 1 };
                    } else if(columnIndex === 6) {
                        return { rowspan: 1, colspan: 7 };
                    }else{
                        return { rowspan: 1, colspan: 0 };
                    }
                }
            },
            initData() {
                if (!!this.id) {
                    outEntrepotDetailById({id: this.id}).then(res=>{
                        this.form = res.data.data;
                        if(!this.form.contentList || this.form.contentList.length==0){
                            this.form.contentList.push({quantity:1,unitPrice:0.00})
                        }
                        let nt = res.data.data.noticeRemark;
                        let amountRow={total: true,categoryName:'合计',quantity:res.data.data.total,remark: !!nt?nt:this.noticeRemark,rows:3}
                        let rk = res.data.data.remark
                        let remarkRow={remarkLast: true,categoryName:'备注',remark:!!rk?rk:'ICCID卡号：（请与实物核对卡号）',rows:4}
                        this.form.contentList.push(amountRow,remarkRow)
                    });
                }
            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            deleteRow(index) {
                if (this.form.contentList.length > 1) {
                    this.form.contentList.splice(index, 1)
                }
            },
            addRow(index){
                this.form.contentList.splice(index + 1, 0, {quantity:1,unitPrice:0.00})
            },
            getNoticeRemark(){
                return this.form.contentList.find(item => item && item.total === true);
            },
            getRemark(){
                return this.form.contentList.find(item => item && item.remarkLast === true);
            },
            getContentList(){
                return this.form.contentList.filter(item => !item.total && !item.remarkLast);
            },
            saveOutEntre(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let formData = Object.assign({},this.form);
                        formData.contentList = this.getContentList();
                        formData.shipmentId = this.shipmentId;
                        formData.shipmentNo = this.shipmentNo;
                        formData.total = this.totalQuantity;
                        let notice = this.getNoticeRemark();
                        formData.noticeRemark = notice && notice.remark
                        let remark = this.getRemark()
                        formData.remark = remark && remark.remark
                        if(!!this.id){
                            editOutEntrepot(formData).then((res) => {
                                this.$message.success("出库单编辑成功");
                                this.$store.dispatch('tagsView/delView', this.$route);
                                this.$router.push("/shipment/outEntrepot");
                            });
                        }else{
                            saveOutEntrepot(formData).then((res) => {
                                this.$message.success("出库单保存成功");
                                this.$store.dispatch('tagsView/delView', this.$route);
                                this.$router.push("/shipment/outEntrepot");
                            });
                        }
                    }
                });
            },
            submitAndFlow(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if(this.form.contentList.length==0){
                            this.$message.error("出库单内容不能全部为空");
                            return
                        }
                        let filteredArray = this.getContentList().filter(function(item) {
                            return !!item.categoryName && !!item.units && !!item.quantity
                        });
                        if(filteredArray.length==0){
                            this.$message.error("出库单品名/数量/单位，不能为空");
                            return
                        }
                        let formData = Object.assign({},this.form);
                        formData.contentList = this.getContentList();
                        formData.shipmentId = this.shipmentId;
                        formData.shipmentNo = this.shipmentNo;
                        formData.total = this.totalQuantity;
                        let notice = this.getNoticeRemark();
                        formData.noticeRemark = notice && notice.remark
                        let remark = this.getRemark()
                        formData.remark = remark && remark.remark
                        submitAndFlowOutEntrepot(formData).then((res) => {
                            this.$message.success("提交出库单成功");
                            this.submitWebSocketMessage();
                            this.$store.dispatch('tagsView/delView', this.$route);
                            this.$router.push("/shipment/outEntrepot");
                        });
                    }
                })
            },
            handleChildEvent(data) {
                this.shipmentNo = data.value;
            },
            submitWebSocketMessage() {
                const message = {
                    key:"entrepot",
                    timestamp: Date.now(),
                };
                webSocketService.sendToTopic('/topic/entrepot', message);
            },
        },
        created() {
            this.initData()
        },
        watch: {
            '$route': {
                handler: function (to, from) {
                    if (to.name == "outEntrepotUpdate") {
                        if (!to.query.id) {
                            this.form = {
                                contentList:[
                                    {quantity:1,unitPrice:0.00}
                                    ,{total: true,categoryName:'合计',remark:'.物联卡机卡绑定，更换设备或被销卡，请联系客服查询；请勿插在手机等移动端使用，经检测将被关停。\n.本产品仅限于在规定的广告机设备上使用，请勿用作他途。',rows:2}
                                    ,{remarkLast: true,categoryName:'备注',remark:'ICCID卡号：（请与实物核对卡号）',rows:4}
                                ]
                            }
                        } else {
                            if (this.id != to.query.id) {
                                this.id = to.query.id;
                                this.initData();
                            }
                        }
                    }
                },
                deep: true,
            },
        },
    };
</script>
<style scoped lang="less">
    @primary: #409EFF;
    @primary-dark: #337ECC;
    @success: #67C23A;
    @danger: #F56C6C;
    @text-primary: #303133;
    @text-regular: #606266;
    @text-secondary: #909399;
    @border-base: #DCDFE6;
    @border-light: #E4E7ED;
    @bg-page: #F0F2F5;
    @bg-section: #F5F7FA;
    @bg-header: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);

    .shipment-page {
        min-height: 100vh;
        background: @bg-page;
        padding: 24px 16px 120px;
        box-sizing: border-box;
    }

    /* ================= 容器 ================= */
    .table-container {
        max-width: 1200px;
        margin: 0 auto;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        position: relative;
        &.flow-container {
            margin-top: 16px;
            .shipment-wrap {
                padding: 16px;
            }
        }
    }

    /* ================= 标题区域 ================= */
    .page-header {
        display: flex;
        align-items: center;
        padding: 20px 28px;
        background: @bg-header;
        color: #fff;
        position: relative;
        &.flow-header {
            padding: 16px 28px;
            .header-title { font-size: 18px; }
        }
    }
    .header-bar {
        width: 5px;
        height: 36px;
        background: #fff;
        border-radius: 3px;
        margin-right: 14px;
        opacity: 0.85;
    }
    .header-content {
        flex: 1;
    }
    .header-title {
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 2px;
        line-height: 1.2;
    }
    .header-sub {
        margin-top: 4px;
        font-size: 12px;
        letter-spacing: 1.5px;
        opacity: 0.7;
    }

    /* ================= 表单区 ================= */
    .form-body {
        padding: 20px 24px;
    }

    .customer-row {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .customer-label {
            width: 92px;
            text-align: center;
            font-weight: 500;
            color: @text-regular;
            font-size: 14px;
            flex-shrink: 0;
        }
        .required-star {
            color: @danger;
            margin-right: 2px;
        }
        .customer-input {
            width: 260px;
        }
    }

    /* ================= 出库表格 ================= */
    .content-table {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;
        /deep/ .el-table__header th {
            background: @bg-section;
            color: @text-regular;
            font-weight: 600;
            font-size: 13px;
            border-color: @border-light !important;
        }
        /deep/ .el-table__body td {
            border-color: @border-light !important;
            text-align: center;
        }
        /deep/ .el-table {
            border: 1px solid @border-light;
            border-radius: 4px;
        }
        /deep/ .el-table td, /deep/ .el-table th.is-leaf {
            border-bottom: 1px solid @border-light;
        }
    }

    .total-label {
        font-weight: 600;
        color: @text-primary;
        font-size: 14px;
    }
    .total-number {
        font-size: 18px;
        font-weight: 700;
        color: @danger;
    }
    .row-index {
        color: @text-secondary;
    }

    /* ================= 备注文本域 ================= */
    /deep/ .remark-textarea .el-textarea__inner {
        font-weight: 600;
        font-size: 13px;
        line-height: 1.6;
    }

    /* ================= 居中输入框 ================= */
    /deep/ .input-center .el-input__inner {
        text-align: center;
    }

    /* ================= 操作列按钮 ================= */
    .action-btn-group {
        // display: flex;
        // align-items: center;
        // gap: 6px;
    }
    .icon-circle-btn {
        width: 28px;
        height: 28px;
        padding: 0;
        font-size: 12px;
        transition: transform 0.15s, box-shadow 0.2s;
        &.is-disabled {
            opacity: 0.4;
        }
        &:not(.is-disabled):hover {
            transform: scale(1.08);
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
        }
        /deep/ i {
            font-weight: 700;
        }
    }
    .icon-add {
        background: @primary;
        border-color: @primary;
        /deep/ i { color: #fff; }
    }
    .icon-delete {
        background: @danger;
        border-color: @danger;
        /deep/ i { color: #fff; }
    }

    /* ================= 签名栏 ================= */
    .footer-signatures {
        margin-top: 16px;
        padding: 14px 0;
        display: flex;
        gap: 80px;
        border-top: 1px dashed @border-light;
        .sig-item {
            font-size: 14px;
            color: @text-regular;
        }
    }

    /* ================= 底部操作栏 ================= */
    .fixed-bottom-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        background: #fff;
        border-top: 1px solid @border-light;
        box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
        padding: 14px 0;
        text-align: center;
        .el-button {
            margin: 0 10px;
            min-width: 100px;
            border-radius: 6px;
        }
    }
</style>
